import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var DEFAULT_CONTEXT = _defineProperty({}, 'people-menu', null);